module.exports = __webpack_public_path__ + "img/list_outlined_64.b9116dfa.svg";